/**
 * @desc Displays multiple data from an array with a customizable delimiter
 * @param {Array} props.data - Array of strings to be processed
 * @param {string} props.delimiter - The symbol to place between elements (defaults to ", ")
 * @returns {Array} 
 */
export default function ArrayDelimiter(props) {
  const { data, delimiter = ", " } = props; // Destructure and set a default
  let result = [];

  if (data && data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      result.push(data[i]);
      // Add delimiter only if it's NOT the last element
      if (i + 1 < data.length) {
        result.push(delimiter);
      }
    }
  }
  return result;
}